<!-- <div class="content-container"> -->
<div class="container page-auction-search">
  <h1 class="font-lg mb-0">Manage Filters</h1>
  <div class="row auction-search-content mt-3">
    <auction-search-filter-show-all class="col-12 auction-search-filter" [filters]="auctionLotService.filters" (updated)="Updated()" (cleared)="Cleared()">
    </auction-search-filter-show-all>
  </div>
</div>
<!-- </div> -->
